<div class="content">
  <form class="vaccination-form" [formGroup]="vaccinationsForm" (submit)="addToList()">
    <mat-form-field>
      <mat-label>{{ 'vaccination' | translate }}</mat-label>
      <input matInput type="text" name="vaccination" formControlName="vaccination" gcFormField gcFormFieldNoError />
    </mat-form-field>
    <mat-form-field class="date-field">
      <mat-label>{{ 'date' | translate }}</mat-label>
      <input matInput type="text" autocomplete="off" [matDatepicker]="startpicker" formControlName="date" (focus)="startpicker.open()" />
      <mat-datepicker-toggle matSuffix [for]="startpicker"></mat-datepicker-toggle>
      <mat-datepicker #startpicker></mat-datepicker>
      <mat-error *ngIf="checkDateValid(vaccinationsForm.controls.date)">This date is invalid</mat-error>
    </mat-form-field>
    <div class="add-content">
      <button mat-flat-button type="submit" class="add-button" [disabled]="vaccinationsForm.invalid">
        <mat-icon svgIcon="plus"></mat-icon>
        {{ 'add_vaccination' | translate }}
      </button>
    </div>
    <div class="divider"></div>
  </form>
  <div *ngIf="historyListForm">
    <form [formGroup]="historyListForm">
      <div class="vaccination-display">
        <mat-accordion multi="true" formArrayName="rowList">
          <mat-expansion-panel class="vaccination-line" *ngFor="let row of rowListControl.controls; let i = index" [formGroupName]="i">
            <mat-expansion-panel-header>
              <mat-panel-description *ngIf="(isMobile$ | async) === false">
                {{ 'vaccination_value' | translate: { value: row.get('vaccination').value } }}
              </mat-panel-description>
              <mat-panel-title>
                {{ 'date_value' | translate: { value: row.get('date').value | customDate: 'dd LLLL yyyy' } }}
              </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="panel-content">
              <mat-form-field class="date-field">
                <mat-label>{{ 'date' | translate }}</mat-label>
                <input
                  matInput
                  type="text"
                  autocomplete="off"
                  [matDatepicker]="startpicker"
                  formControlName="date"
                  (focus)="startpicker.open()"
                />
                <mat-datepicker-toggle matSuffix [for]="startpicker"></mat-datepicker-toggle>
                <mat-datepicker #startpicker></mat-datepicker>
                <mat-error *ngIf="checkDateValid(row.controls.date)">{{ 'this_date_is_invalid' | translate }}</mat-error>
              </mat-form-field>
              <mat-form-field>
                <mat-label>{{ 'vaccination' | translate }}</mat-label>
                <input matInput type="text" name="vaccination" formControlName="vaccination" gcFormField gcFormFieldNoError />
              </mat-form-field>
            </div>
            <button class="delete-button" mat-raised-button color="warn" (click)="deleteRow(i)">
              <mat-icon svgIcon="delete"></mat-icon>
              {{ 'delete' | translate }}
            </button>
          </mat-expansion-panel>
        </mat-accordion>
      </div>
    </form>
  </div>
  <div class="save">
    <button
      mat-flat-button
      [ngClass]="{ primary: requestUuid === null, accent: requestUuid !== null }"
      class="save-button"
      (click)="submit()"
    >
      <mat-icon svgIcon="check"></mat-icon>
      {{ 'save_vaccination' | translate }}
    </button>
  </div>
</div>
